import { ChevronUp } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type ProductionDeclarationScrollToTopButtonProps = {
  visibilityThreshold?: number;
};

export function ProductionDeclarationScrollToTopButton({
  visibilityThreshold = 480,
}: ProductionDeclarationScrollToTopButtonProps) {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation('productionDeclaration', {
    useSuspense: false,
  });

  useEffect(() => {
    const updateVisibility = () => {
      setIsVisible(window.scrollY > visibilityThreshold);
    };

    updateVisibility();
    window.addEventListener('scroll', updateVisibility, {
      passive: true,
    });

    return () => {
      window.removeEventListener('scroll', updateVisibility);
    };
  }, [visibilityThreshold]);

  if (!isVisible) {
    return null;
  }

  return (
    <button
      aria-label={t('scrollToTop')}
      className='fixed right-6 bottom-6 z-30 inline-flex size-14 items-center justify-center rounded-full bg-declaration-primary text-white shadow-[0_18px_40px_rgba(56,78,57,0.24)] transition-colors hover:bg-declaration-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-declaration-primary focus-visible:ring-offset-2 sm:right-8 sm:bottom-8'
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      type='button'
    >
      <ChevronUp className='size-6' strokeWidth={2.25} />
    </button>
  );
}
